/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'iconCilp': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" class="st0" d="M5.2 14.1c-.9 0-1.8-.3-2.4-1-.6-.6-1-1.4-1-2.3 0-.9.3-1.7.9-2.3L9 2.6c1-.9 2.5-.9 3.5.1.9 1 .9 2.5 0 3.4l-5.8 5.5c-.3.3-.6.4-1 .4s-.7-.2-1-.4c-.6-.7-.5-1.6.1-2.1l4.4-4.1c.1-.4.4-.4.6-.2.2.2.2.5 0 .7L5.4 10c-.2.2-.2.5 0 .7.1.1.2.1.3.1.1 0 .2 0 .3-.1l5.8-5.4c.6-.6.6-1.5 0-2-.6-.6-1.5-.6-2.1 0L3.5 9.2c-.5.5-.7 1-.7 1.6 0 .6.2 1.2.7 1.6.9.9 2.4 1 3.4.1l6.4-6c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-6.4 6c-.7.6-1.5.9-2.4.9z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/iconCilp.js